// assets/product-scroll-guard.js
(function () {
  // Solo en páginas de producto
  if (!/\/products\//.test(location.pathname)) return;

  // Solo si venimos de colecciones (evita afectar entradas directas desde Google, etc.)
  var fromCollection = (function () {
    try {
      if (!document.referrer) return false;
      var u = new URL(document.referrer);
      return /\/collections\//.test(u.pathname);
    } catch (e) { return false; }
  })();
  if (!fromCollection) return;

  // Desactiva restauración automática del navegador en este documento
  try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch (e) {}

  function hardSnapTop() {
    try {
      // quita suavizado y fuerza 0 en todos los sitios posibles
      var html = document.documentElement;
      var body = document.body;
      var prev = html.style.scrollBehavior;
      html.style.scrollBehavior = 'auto';
      html.scrollTop = 0;
      body.scrollTop = 0;
      window.scrollTo(0, 0);
      html.style.scrollBehavior = prev || '';
    } catch (e) {}
  }

  // Mantiene el scroll en 0 durante X ms, aunque el layout cambie
  function holdTop(ms) {
    var end = Date.now() + ms;
    var stable = 0;

    function tick() {
      // si por algún motivo subió, lo llevamos arriba
      if (window.scrollY > 0) {
        hardSnapTop();
        stable = 0;
      } else {
        stable++;
      }
      // salimos si llevamos varios frames “estables” o se acabó el tiempo
      if (Date.now() < end && stable < 20) {
        requestAnimationFrame(tick);
      }
    }
    requestAnimationFrame(tick);
  }

  // Observa cambios grandes en el DOM y, si empujan el contenido, vuelve a 0
  function watchMutations(durationMs) {
    var end = Date.now() + durationMs;
    var obs;
    try {
      obs = new MutationObserver(function () {
        if (window.scrollY > 0) hardSnapTop();
      });
      obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, durationMs + 200);
    } catch (e) {}
  }

  // Ciclos de carga: forzamos top y sujetamos unos segundos
  function run() {
    hardSnapTop();
    // sujeta 2.5s (ajustable). Suficiente para headers/medias/lazyloaders del tema
    holdTop(2500);
    watchMutations(2500);
    // refuerzo tardío por si algo se inyecta luego
    [600, 1200, 1800, 2400].forEach(function (t) { setTimeout(hardSnapTop, t); });
  }

  // Ejecuta en distintos hitos
  run();
  document.addEventListener('DOMContentLoaded', run, { once: true });
  window.addEventListener('load', run, { once: true });
  window.addEventListener('pageshow', run, { once: true });
})();
